<div class="min-w-[300px] max-w-[450px] h-full border-primary border-[1px] rounded-[16px] shadow p-0">
    <div class="relative rounded-t-[16px] overflow-hidden">
        <img src="{{imageSrc}}" alt="" class="w-full h-40 object-cover">

        <div class="absolute bottom-4 left-6 flex gap-2 items-center">
            <img src="{{iconSrc}}" class="w-[24px] h-[24px] drop-shadow" alt="{{ 'shared.icon' | transloco }}">
            <h2 class="text-xl font-bold text-white drop-shadow">{{title}}</h2>
        </div>
    </div>

    <div class="flex flex-col gap-5 justify-between items-center text-center p-5">
        <p class="text-neutral-600 text-lg mobile:text-base mb-4 min-h-[50px]">
            {{description}}
        </p>
        <div class="w-[300px] h-[50px]">
            <app-custom-button [buttonText]="buttonText" backgroundColor="bg-primary" textColor="text-white"
                borderColor="border-primary" hoverBackgroundColor="hover:bg-primary-1200" fontWeight="font-bold"
                (buttonClick)="onClick()"></app-custom-button>
        </div>
    </div>